<div cdkTrapFocus>
  <article class="dt-l-article" *ngIf="!isLoading">
    <div class="dt-l-article__content">
      <div class="dt-l-article__section__logo">
        <img
          [attr.alt]="'UI_COMPANY_LOGO' | translate"
          src="assets/img/logo-default.png"
          [style.max-width]="maxWidth"
          alt="Logo – {{ applicationName }}" />
      </div>

      <section class="dt-l-article__section">
        <h1 class="dt-l-article__section__title" tabindex="-1">
          {{ 'PAGE_HEADING' | translate }}
        </h1>
        <p class="dt-l-article__section__description" [innerHtml]="pageSubheading"></p>

        <form [formGroup]="unlockForm" (ngSubmit)="unlockWithPassword()">
          <div class="dt-f-item type:password">
            <div class="dt-f-item__element">
              <div class="dt-f-item__infix">
                <input
                  #inputPassword
                  type="password"
                  formControlName="userPassword"
                  placeholder="{{ 'PASSWORD' | translate }}"
                  autocomplete="off"
                  required />
              </div>
              <button
                #buttonTooglePassword
                [attr.aria-label]="'UI_SHOWPASSWORD' | translateAria"
                type="button"
                class="dt-f-item__action"
                (click)="togglePassword()">
                <i #iconTooglePassword aria-hidden="true" class="ui-icon-eye"></i>
              </button>
            </div>
          </div>
          <div class="dt-l-button-group__vertical">
            <button
              type="submit"
              class="dt-c-button primary orderButtonVertical"
              [disabled]="unlockForm.invalid || !unlockForm.dirty">
              {{ 'UNLOCK' | translate }}
            </button>
            <button
              [attr.aria-label]="'UI_TOUCH_ID' | translateAria"
              type="button"
              *ngIf="unlockWithFingerprint && biometricAvailable"
              (click)="unlockWithBiometric()"
              class="dt-c-button transparent orderButtonVertical dt-c-button--biometric">
              <i aria-hidden="true" class="ui-icon-touch-id" style="font-size: 2em"></i>&nbsp;&nbsp;&nbsp;<i
                aria-hidden="true"
                class="ui-icon-face-id"
                style="font-size: 2em"></i>
            </button>
            <button
              type="button"
              (click)="requestPassword()"
              class="dt-c-button transparent text-small orderButtonVertical">
              {{ 'FORGOT_PASSWORD' | translate }}
            </button>
            <button type="button" (click)="logout()" class="dt-c-button transparent text-small orderButtonVertical">
              {{ 'LOGIN_WITH_OTHER_ACCOUNT' | translate }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </article>
</div>
